import { render, staticRenderFns } from "./SimplePieMulti.vue?vue&type=template&id=b670227c&scoped=true&"
import script from "./SimplePieMulti.vue?vue&type=script&lang=js&"
export * from "./SimplePieMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b670227c",
  null
  
)

export default component.exports